module.exports = __webpack_public_path__ + "img/img_market_con6.4f75b438.png";